angular.module('gym.calendar').controller('SelectBookingTypeCtrl', ["$scope", "$modalInstance", "event", "contact", function($scope, $modalInstance, event, contact) {
  $scope.event = event;
  $scope.contact = contact;
  $scope.booking = {
    free_class: false
  };
  $scope.enabledMakeupClass = function() {
    var ref;
    $scope.booking.add_makeup_class = true;
    $scope.booking.free_class = false;
    if (!$scope.booking.makeup_class_membership_id) {
      return $scope.booking.makeup_class_membership_id = (ref = contact.memberships_for_makeup_classes[0]) != null ? ref.id : void 0;
    }
  };
  $scope.toggleFreeClass = function(value) {
    $scope.booking.free_class = value;
    $scope.booking.add_makeup_class = false;
    $scope.booking.makeup_class_membership_id = void 0;
    return $scope.booking.makeup_class_reason = void 0;
  };
  $scope.makeupClassOptionVisible = function() {
    return $scope.contact.show_makeup_class_option;
  };
  $scope.isInvalid = function() {
    return $scope.contact.show_makeup_class_option && !$scope.booking.free_class && !$scope.booking.add_makeup_class;
  };
  $scope.save = function() {
    return $modalInstance.close($scope.booking);
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
